import React, { Component } from 'react';
import PerimetreContext from '../../contexts/PerimetreContext';
import { EUIPage } from '../EUI/EUIPage';

export class Operation extends Component {
    static contextType = PerimetreContext;
    render = () => {
        const { perimetre } = this.context;
        return <OperationWithPerimetre {...this.props} perimetre={perimetre} />;
    };
};

class OperationWithPerimetre extends Component {

    static defaultProps = {
        perimetre: {}
    };

    //constructor(props) {
    //    super(props);
    //    this.state = {
    //        idOperation: 0,
    //        idProgramme: 0
    //    }
    //}

    //_recuperationPerimetre = () => {
    //    var verificationSiPerimetreExiste = Data._verificationSiPerimetreExiste();
    //    verificationSiPerimetreExiste
    //        .then(responseFetch => {
    //            const valeurRetour = responseFetch.reponseAPIobjet;

    //            this.setState({ idOperation: valeurRetour[0], idProgramme: valeurRetour[7] });
    //        });
    //}

    //componentDidMount = () => {
    //    this._recuperationPerimetre();
    //}

    //componentDidUpdate = () => {
    //    if (localStorage.getItem("onRecharge") === "true") {
    //        this._recuperationPerimetre();
    //    }

    //    if (localStorage.getItem("onSelectionneOperation") === "true") {
    //        this._recuperationPerimetre();
    //        localStorage.removeItem('onSelectionneOperation');
    //    }
    //}

    render = () => {

        //const sousMenuActif = this.state.idOperation > 0;
        const { perimetre } = this.props;
        const { idOperation, idProgramme } = perimetre;
        const isIdentificationProgrammeDisabled = !idProgramme;
        const isIdentificationOperationDisabled = !idOperation;

        return <EUIPage
            baseUrl="/Operations"
            onglets={[
                { url: "/ListeOperations", titre: "Liste des opérations" },
                { url: "/IdentificationProgramme", titre: "Identification programme", disabled: isIdentificationProgrammeDisabled },
                { url: "/IdentificationOperation", titre: "Identification opération", disabled: isIdentificationOperationDisabled },
                { url: "/GrilleDePrix", titre: "Grille de prix", disabled: isIdentificationOperationDisabled },
                { url: "/ImportExport", titre: "Import/Export de lots", disabled: isIdentificationOperationDisabled },
                { url: "/DossierClientType", titre: "Dossier client type", disabled: isIdentificationOperationDisabled },
                { url: "/MandatCommercialisation", titre: "Mandats de commercialisation", disabled: isIdentificationOperationDisabled },
            ]}
        />;

    };

};